import styled from 'styled-components';
const BaseButton = styled.button.attrs(({ type }) => ({ type }))`
   border-radius: 10px;
   width: 90%;
   max-width: 400px;
   background: ${({ theme }) => theme.primaryBlueLight};
   border: none;
   color: ${({ theme }) => theme.secondaryWhite};
   margin: 0.8rem auto;
   position: relative;
   font-size: 1.2em;
   font-weight: 700;
   &:hover {
      cursor: pointer;
      background-color: ${({ theme }) => theme.primaryBlueDark};
   }

   &[disabled] {
      color: ${({ theme }) => theme.primaryGrey};
      background-color: ${({ theme }) => theme.disabled};
      cursor: default;
      border: 1px solid ${({ theme }) => theme.disabled};
   }
`;

export default BaseButton;
